<template>
  <ul class="menu-nav">
    <template v-for="(item, index) in menu">
      <template v-if="!item.hasOwnProperty('children')">
        <router-link
          v-bind:key="index"
          :to="item.link"
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
              isActive && 'menu-item-active',
              isExactActive && 'menu-item-active'
            ]"
          >
            <a :href="href" class="menu-link" @click="navigate">
              <i :class="`menu-icon ${item.icon}`"></i>
              <span class="menu-text"> {{ $t(item.text) }} </span>
            </a>
          </li>
        </router-link>
      </template>
      <template v-else>
        <li
          v-bind:key="index"
          aria-haspopup="true"
          data-menu-toggle="click"
          class="menu-item menu-item-submenu menu-item-open-dropdown"
          v-bind:class="{
            'menu-item-active': hasActiveChildren(item.link)
          }"
        >
          <a href="#" class="menu-link menu-toggle">
            <span class="menu-text"> {{ $t(item.text) }} </span>
          </a>

          <div class="menu-submenu menu-submenu-classic">
            <ul class="menu-subnav">
              <template v-for="(subMenu, subMenuIndex) in item.children">
                <template v-if="!hasNestedChildren(subMenu)">
                  <router-link
                    :to="subMenu.link"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                    v-bind:key="subMenuIndex"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active'
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot"><span></span></i>
                        <span class="menu-text">
                          {{ $t(subMenu.text) }}
                        </span>
                      </a>
                    </li>
                  </router-link>
                </template>
                <template v-else>
                  <li
                    v-bind:key="subMenuIndex"
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item menu-item-submenu"
                  >
                    <a href="#" class="menu-link menu-toggle">
                      <i class="menu-icon flaticon2-list-2"></i>
                      <span class="menu-text">{{ $t(subMenu.text) }}</span>
                      <i class="menu-arrow"></i>
                    </a>
                    <div
                      class="menu-submenu menu-submenu-classic menu-submenu-right"
                    >
                      <ul class="menu-subnav">
                        <router-link
                          v-for="(nestedItem,
                          nestedItemIndex) in subMenu.children"
                          :key="nestedItemIndex"
                          :to="nestedItem.link"
                          v-slot="{ href, navigate, isActive, isExactActive }"
                        >
                          <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                              isActive && 'menu-item-active',
                              isExactActive && 'menu-item-active'
                            ]"
                          >
                            <a :href="href" class="menu-link" @click="navigate">
                              <i class="menu-bullet menu-bullet-dot"
                                ><span></span
                              ></i>
                              <span class="menu-text">
                                {{ $t(nestedItem.text) }}
                              </span>
                            </a>
                          </li>
                        </router-link>
                      </ul>
                    </div>
                  </li>
                </template>
              </template>
            </ul>
          </div>
        </li>
      </template>
    </template>
  </ul>
</template>

<script>

import moduleUser, {
  MODULE_NAME as MODULE_USER, SELF
} from "@/core/services/store/user.module";
import store from "@/core/services/store";

const _MODULE_USER = MODULE_USER;

export default {
  name: "KTMenu",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_USER, moduleUser);
  },
  computed: {
    menu() {
      let user = this.$store.getters[_MODULE_USER + "/" + SELF];
      let items = user && user.hasOwnProperty("menu") ? user.menu : [];
      items = items.filter(item => {
        return item.is_web;
      })
      return items;
    }
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    hasNestedChildren(menu) {
      return menu.hasOwnProperty("children");
    }
  }
};
</script>
